module.exports = __webpack_public_path__ + "js/0.878cfb6e.worker.js"